import { StyleSheet } from 'react-native'
import { Theme } from '@theme'

// Styles pour le système listingContacts
export const getListingContactsStyles = (theme: Theme) => {
  return StyleSheet.create({
    container: {
      paddingHorizontal: theme.spacing.lg,
    },
    containerSearch: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
    containerSearchBar: {
      flex: 1,
      maxWidth: 400,
      paddingHorizontal: theme.spacing.lg,
    },
    containerList: {
      flex: 1,
      flexDirection: 'row',
      alignItems: 'flex-start',
    },
    // Barre de recherche
    searchbarContainer: {
      paddingHorizontal: 16,
      paddingVertical: 8,
      backgroundColor: theme.colors.background,
    },
    
    searchbar: {
      backgroundColor: theme.colors.card,
      borderRadius: 50,
      elevation: 2,
      shadowColor: theme.colors.text,
      shadowOffset: { width: 0, height: 1 },
      shadowOpacity: 0.1,
      shadowRadius: 2,
      marginTop: 16,
    },
    
    // Section des filtres
    filtersContainer: {
      paddingHorizontal: 16,
      paddingVertical: 8,
      backgroundColor: theme.colors.background,
    },
    
    filtersRow: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
    
    scopeContainer: {
      flexDirection: 'row',
      backgroundColor: theme.colors.card,
      borderRadius: 8,
      padding: 2,
      flex: 1,
      marginRight: 12,
    },
    
    scopeButton: {
      flex: 1,
      paddingVertical: 8,
      paddingHorizontal: 12,
      borderRadius: 6,
      alignItems: 'center',
    },
    
    scopeButtonActive: {
      backgroundColor: theme.colors.primary,
    },
    
    scopeButtonInactive: {
      backgroundColor: 'transparent',
    },
    
    scopeText: {
      fontSize: 14,
      fontWeight: '500',
    },
    
    scopeTextActive: {
      color: theme.colors.background,
    },
    
    scopeTextInactive: {
      color: theme.colors.text,
    },
    
    filterButton: {
      flexDirection: 'row',
      alignItems: 'center',
      backgroundColor: theme.colors.card,
      paddingHorizontal: 12,
      paddingVertical: 8,
      borderRadius: 8,
      elevation: 1,
      shadowColor: theme.colors.text,
      shadowOffset: { width: 0, height: 1 },
      shadowOpacity: 0.1,
      shadowRadius: 1,
    },
    
    filterButtonActive: {
      backgroundColor: theme.colors.primary,
    },
    
    filterButtonText: {
      fontSize: 14,
      fontWeight: '500',
      marginLeft: 4,
    },
    
    filterButtonTextActive: {
      color: theme.colors.background,
    },
    
    filterButtonTextInactive: {
      color: theme.colors.text,
    },
    
    // Badge de compteur de filtres
    filterBadge: {
      position: 'absolute',
      top: -4,
      right: -4,
      backgroundColor: theme.colors.notification,
      borderRadius: 10,
      minWidth: 20,
      height: 20,
      alignItems: 'center',
      justifyContent: 'center',
    },
    
    filterBadgeText: {
      color: theme.colors.background,
      fontSize: 12,
      fontWeight: 'bold',
    },
    
    // Liste des contacts
    listContainer: {
      flex: 1,
      paddingHorizontal: 16,
    },
    
    contactItem: {
      flexDirection: 'row',
      alignItems: 'center',
      backgroundColor: theme.colors.card,
      padding: 16,
      marginVertical: 4,
      borderRadius: 12,
      elevation: 2,
      shadowColor: theme.colors.text,
      shadowOffset: { width: 0, height: 1 },
      shadowOpacity: 0.1,
      shadowRadius: 2,
    },
    
    contactAvatar: {
      width: 50,
      height: 50,
      borderRadius: 25,
      backgroundColor: theme.colors.primary,
      alignItems: 'center',
      justifyContent: 'center',
      marginRight: 12,
    },
    
    contactAvatarText: {
      color: theme.colors.background,
      fontSize: 18,
      fontWeight: 'bold',
    },
    
    contactInfo: {
      flex: 1,
    },
    
    contactName: {
      fontSize: 16,
      fontWeight: '600',
      color: theme.colors.text,
      marginBottom: 4,
    },
    
    contactHashtags: {
      flexDirection: 'row',
      flexWrap: 'wrap',
      marginTop: 4,
    },
    
    hashtag: {
      backgroundColor: theme.colors.primary + '20',
      paddingHorizontal: 8,
      paddingVertical: 2,
      borderRadius: 12,
      marginRight: 4,
      marginBottom: 2,
    },
    
    hashtagText: {
      fontSize: 12,
      color: theme.colors.primary,
      fontWeight: '500',
    },
    
    contactActions: {
      flexDirection: 'row',
      alignItems: 'center',
    },
    
    actionButton: {
      padding: 8,
      marginLeft: 8,
      borderRadius: 20,
      backgroundColor: theme.colors.primary + '20',
    },
    
    // États vides
    emptyContainer: {
      flex: 1,
      alignItems: 'center',
      justifyContent: 'center',
      paddingHorizontal: 32,
    },
    
    emptyIcon: {
      marginBottom: 16,
    },
    
    emptyTitle: {
      fontSize: 18,
      fontWeight: '600',
      color: theme.colors.text,
      textAlign: 'center',
      marginBottom: 8,
    },
    
    emptyMessage: {
      fontSize: 14,
      color: theme.colors.text + '80',
      textAlign: 'center',
      lineHeight: 20,
    },
    
    // Statistiques
    statsContainer: {
      paddingHorizontal: 16,
      paddingVertical: 8,
      backgroundColor: theme.colors.card,
      borderTopWidth: 1,
      borderTopColor: theme.colors.border,
    },
    
    statsText: {
      fontSize: 12,
      color: theme.colors.text + '80',
      textAlign: 'center',
    },
    
    // Loading
    loadingContainer: {
      flex: 1,
      alignItems: 'center',
      justifyContent: 'center',
    },
    
    loadingText: {
      marginTop: 16,
      fontSize: 16,
      color: theme.colors.text,
    },
  })
} 